import { useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { AesUtil } from '../js/AesUtil';
import { current_client_config, LAUNCHED } from '../config/Constant';
import { checkBookingStatus } from '../Redux/Actions/checkInAction';
import { handleBookingDataState, handlePreCheckInDataState } from '../js/handleBookingState';

/**
 * Custom hook to manage booking and pre-checkin state
 * Handles loading, validation, and cleanup of booking data from AsyncStorage
 */
export const useBookingState = () => {
    const dispatch = useDispatch();
    const checkedBookingState = useRef(false);

    const { isBookingFound, bookingData } = useSelector(
        state => ({
            isBookingFound: state.checkInSlice.bookingStatus.isBookingFound,
            bookingData: state.checkInSlice.bookingStatus.bookingData,
            isLoggedIn: state.appConfigSlice.isLoggedIn,
            initAppLogout: state.appConfigSlice.initAppLogout,
        }),
        shallowEqual
    );

    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice, shallowEqual);

    // Load booking and pre-checkin data when server time is available
    useEffect(() => {
        if (Object.keys(serverTimeDataObj).length > 0 && current_client_config) {
            dispatch(handleBookingDataState());
            dispatch(handlePreCheckInDataState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serverTimeDataObj]);




    // Check booking status when booking is found
    useEffect(() => {
        if (isBookingFound && !checkedBookingState.current) {
            checkedBookingState.current = true;
            dispatch(checkBookingStatus(bookingData, "", LAUNCHED));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBookingFound]);



    return null;
};
